import { useState, useEffect, useRef, Fragment, memo, useMemo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./NewPhoto.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import EXIF from 'exif-js';
import { getCountyAndTown } from "../../comm/comm";
import { GameContext } from "../../GameContext";
import apiManager from '../../ApiManager';
const NewPhoto = ({ setModalType, arg, addModalType }) => {
    const { userData } = useContext(GameContext);
    const [inProp, setInProp] = useState(false);
    const [selectInd, set_selectInd] = useState(0);
    const [feel, set_feel] = useState(["美景", "趣味", "珍藏"]);
    const [data, set_data] = useState([
        { file: null, url: "", position: {}, msg: "" },
        { file: null, url: "", position: {}, msg: "" },
        { file: null, url: "", position: {}, msg: "" },
    ]);
    useEffect(() => {
        console.log("userData", userData)
        setInProp(true);
    }, [])
    const handleFileChange = (e) => {
        const file = e.target.files[0];

        const promises = getGpsData(file);
        promises.then(async (result) => {
            console.log(selectInd, result);
            const location = await getCountyAndTown(result.latitude, result.longitude);
            set_data(props => {
                let _props = [...props];
                _props[selectInd].file = result.file;
                _props[selectInd].url = result.imageUrl;
                _props[selectInd].formattedDate = result.formattedDate;
                _props[selectInd].position = { lat: result.latitude, lng: result.longitude };

                _props[selectInd].location = location;
                console.log("_props", _props)
                return _props;
            });
        });
    };

    const getGpsData = (file) => {
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.onload = () => {
                EXIF.getData(file, function () {
                    const lat = EXIF.getTag(this, 'GPSLatitude');
                    const lon = EXIF.getTag(this, 'GPSLongitude');
                    const latRef = EXIF.getTag(this, 'GPSLatitudeRef');
                    const lonRef = EXIF.getTag(this, 'GPSLongitudeRef');
                    const dateTimeOriginal = EXIF.getTag(this, 'DateTimeOriginal');
                    const imageUrl = URL.createObjectURL(file);
                    let latitude, longitude, formattedDate;

                    if (lat && lon && latRef && lonRef) {
                        latitude = convertDMSToDD(lat, latRef);
                        longitude = convertDMSToDD(lon, lonRef);
                    }

                    if (dateTimeOriginal) {
                        formattedDate = formatDate(dateTimeOriginal);
                    }

                    resolve({
                        file: file,
                        imageUrl,
                        latitude,
                        longitude,
                        formattedDate
                    });
                });
            };
            reader.readAsArrayBuffer(file);
        });
    };

    const convertDMSToDD = (dms, ref) => {
        const degrees = dms[0] + dms[1] / 60 + dms[2] / 3600;
        return ref === 'S' || ref === 'W' ? -degrees : degrees;
    };
    const formatDate = (dateTime) => {
        const [date, time] = dateTime.split(' ');
        const [year, month, day] = date.split(':');
        return `${year}.${month}.${day}`;
    };
    const canNext = () => {
        return (data[selectInd].file && data[selectInd].feelInd > -1)
    }
    function submit() {
        console.log(data);
        const fnArr = {}
        addModalType({
            cls: "Loading", arg: { fnArr: fnArr, str: "照片上傳中..." }
        })
        function uploadEnd(success) {
            fnArr.doCloseFn();
            if (success) {
                const fnArr = {}
                addModalType({
                    cls: "UploadAni", arg: {
                        fnArr: fnArr,
                        cb: (type) => {
                            if (type === "loop") {
                                addModalType({
                                    cls: "PhotoFeeling", arg: {
                                        cb: experience => {
                                            console.log("experience", experience);
                                            if(experience===-1)
                                            {
                                                fnArr.doCloseFn();
                                                arg.cb();
                                            }
                                            else {
                                                apiManager.fetchPost(`collaborative-log/${arg.eventId}/experience`, { "events_experience": `EXPERIENCE_${experience}` }).then(res => {
                                                    console.log("experience",res);
                                                    fnArr.doCloseFn();
                                                    arg.cb();
                                                })
                                            }
                                        }
                                    }
                                })
                            }
                            else if (type === "end") {
                                setInProp(false);
                            }
                        }
                    }
                })
            }
        }
        function updateFile(ind) {
            const obj = data[ind];
            if (obj && obj.file) {
                var formdata = new FormData();
                formdata.append("event_polaroids_tag", `f${obj.feelInd}`);
                formdata.append("event_polaroids_message", obj.msg);
                formdata.append("event_polaroids_file", obj.file);
                for (var pair of formdata.entries()) {
                    console.log(pair[0] + ': ' + pair[1]);
                }
                apiManager.fetchPostForm(`collaborative-log/${arg.eventId}/polaroids`, formdata).then(res => {
                    if (res.message) {
                        alert(res.message);
                        uploadEnd(false);
                    }
                    else {
                        console.log(res);
                        updateFile(ind + 1);
                    }
                }).catch(errObj=>{
                    alert("上傳失敗");
                    uploadEnd(false);
                })
            }
            else {
                uploadEnd(true);
            }
        }
        updateFile(0);
    }
    const getCount=()=>{
        return data.filter(item => item.file !== null).length;
    }
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "NewPhoto"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <IconButton onClick={e => {
                                        addModalType({
                                            cls: "AlertCustom", arg: {
                                                type: 2,
                                                title: "捨棄編輯？",
                                                desc1: "所有內容將消失成泡影。",
                                                desc2: "",
                                                options: [
                                                    {
                                                        label: "捨棄", color: "black", cb: () => {
                                                            setInProp(false)
                                                        }
                                                    },
                                                    {
                                                        label: "取消", color: "white", cb: () => {
                                                        }
                                                    }
                                                ],
                                            }
                                        })
                                    }}>
                                        <ArrowBackIosNewIcon />
                                    </IconButton>
                                    <YStyled.Span size={17} >編輯拍立得</YStyled.Span>
                                </div>
                                <div className={styleUi.view}>
                                    <div className={styleUi.list}>
                                        {data[selectInd].file ?
                                            <div className={styleUi.photo}>
                                                <img src={data[selectInd].url} />
                                                <div className={styleUi.delBtn}>
                                                    <img src="./assets/ui/x.png" onClick={e => {
                                                        set_data(prev => {
                                                            const _prev = [...prev];
                                                            _prev[selectInd].file = null;
                                                            _prev[selectInd].url = null;
                                                            return _prev;
                                                        })
                                                    }} />
                                                </div>
                                                <YStyled.Row>
                                                    {data[selectInd].location &&
                                                        <YStyled.Label style={{ padding: "4px 10px", borderRadius: "18px", background: "#F8F8F8" }}>
                                                            <YStyled.Span size={11} >{data[selectInd].location}</YStyled.Span>
                                                        </YStyled.Label>
                                                    }
                                                    {data[selectInd].formattedDate &&
                                                        <YStyled.Label style={{ padding: "4px 10px", borderRadius: "18px", background: "#F8F8F8" }}>
                                                            <YStyled.Span size={11} >{data[selectInd].formattedDate}</YStyled.Span>
                                                        </YStyled.Label>
                                                    }
                                                </YStyled.Row>
                                                <YStyled.Label style={{ padding: "4px 10px", borderRadius: "18px", background: "#F8F8F8", width: "100%", justifyContent: "flex-start" }}>
                                                    <YStyled.Input maxLength={20} placeholder="留言...（20字內）" value={data[selectInd].msg} onChange={e => {
                                                        set_data(prev => {
                                                            const _prev = [...prev];
                                                            _prev[selectInd].msg = e.target.value;
                                                            return _prev;
                                                        })
                                                    }}></YStyled.Input>
                                                </YStyled.Label>
                                                <YStyled.Label style={{ padding: "4px 10px", borderRadius: "18px", background: "#F8F8F8", alignSelf: "flex-end" }}>
                                                    <YStyled.Span size={11} >{userData.users_name}</YStyled.Span>
                                                </YStyled.Label>
                                            </div>
                                            :
                                            <div className={styleUi.photo}>
                                                <label>
                                                    <img src="./assets/ui/add_cw.png" />
                                                    <YStyled.Span size={13} fontWeight={400} fontFamily="SF Pro">上傳照片</YStyled.Span>
                                                    <input type="file" accept="image/*" onChange={e => { handleFileChange(e) }} />
                                                </label>
                                            </div>}
                                    </div>
                                    <div className={`${styleUi.feelingBox} ${data[selectInd].file ? "" : styleUi.hidden}`}>
                                        <YStyled.Span size={13} fontWeight={600} fontFamily="SF Pro">下列最符合你照片的主題是：</YStyled.Span>
                                        <div className={`${styleUi.feeling} `}>
                                            {feel.map((v, k) => {
                                                return <div key={k} className={`${styleUi.item} ${data[selectInd].feelInd === k ? styleUi.selected : ""}`} onClick={e => {
                                                    set_data(prev => {
                                                        const _prev = [...prev];
                                                        _prev[selectInd].feelInd = k;
                                                        return _prev;
                                                    })
                                                }}><YStyled.Span size={15} fontWeight={500} fontFamily="SF Pro">{v}</YStyled.Span></div>
                                            })}
                                        </div>
                                    </div>
                                    <div className={styleUi.ctrlPanel}>
                                        {selectInd > 0 &&
                                            < button className={styleUi.pageBtn} style={{ left: "5%" }} onClick={e => {
                                                set_selectInd(p => p -= 1);
                                            }}>
                                                <ArrowBackIcon />
                                            </button>
                                        }
                                        <div className={styleUi.dotList}>
                                            {data.map((v, k) => {
                                                return <div key={k} className={`${styleUi.dot} ${selectInd === k ? styleUi.selected : ""}`}></div>
                                            })}
                                        </div>
                                        {selectInd < 2 &&
                                            <button disabled={!canNext()} className={styleUi.pageBtn} style={{ right: "5%" }} onClick={e => {
                                                set_selectInd(p => p += 1);
                                            }}>
                                                <ArrowForwardIcon />
                                            </button>
                                        }
                                    </div>


                                    <button disabled={getCount()===0} className={`${styleUi.btn}`} onClick={e => {
                                        if (selectInd < 2) {
                                            addModalType({
                                                cls: "AlertCustom", arg: {
                                                    type: 2,
                                                    title: "繼續上傳嗎？",
                                                    desc1: `你有 3 張拍立得空間，還有 ${3 - getCount()} 張可以新增。`,
                                                    desc2: "上傳完畢後，所有拍立得將無法再編輯。",
                                                    options: [
                                                        {
                                                            label: "繼續上傳下一張", color: "black", cb: () => {
                                                                set_selectInd(p => p += 1);
                                                            }
                                                        },
                                                        {
                                                            label: "上傳完畢", color: "white", cb: () => {
                                                                submit();
                                                            }
                                                        }
                                                    ],
                                                }
                                            })
                                        }
                                        else {
                                            submit();
                                        }
                                    }}>
                                        <YStyled.Span size={17} >完成</YStyled.Span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition >
        </div >
    );
}

export default memo(NewPhoto);